import { API_ENDPOINTS } from 'services/api';
import httpClient from 'services/httpClient';
import { CompetencyData, ICompetencyFormData } from 'types/dacum/competencyManagement';

interface Params {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  status?: string;
  sortBy?: string;
  startDate?: string;
  endDate?: string;
  schoolId?: string | null;
  sortOrder?: 'asc' | 'desc';
}

interface CompetencyResponse {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  message: string;
  data: CompetencyData[];
}

export const dacumService = {
  createCompetency: async (data: ICompetencyFormData) => {
    const response = await httpClient.post(API_ENDPOINTS.DACUM.COMPETENCY_MANAGEMENT.ADD, data);
    return response.data;
  },
  getCompetency: async (params?: Params): Promise<CompetencyResponse> => {
    const response = await httpClient.get<CompetencyResponse>(
      API_ENDPOINTS.DACUM.COMPETENCY_MANAGEMENT.LIST,
      {
        params
      }
    );
    return response.data;
  }
};
